import React, { Component } from 'react';
import {Table, Button, Input} from 'reactstrap';
import './DuePaymentsList.css';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { sharedLabelsPath } from "../../../../reducers/common/localization";
import { CURRENCIES } from '../../../../constants/constants';
import BAWireDataModal from './wireDataModal/BAWireDataModal.container';
import UniversityWireDataModal from './wireDataModal/UniversityWireDataModal.container';
import BADuePaymentsConfirmModal from './duePaymentsConfirmModal/BADuePaymentsConfirmModal.container';
import UniversityDuePaymentsConfirmModal from './duePaymentsConfirmModal/UniversityDuePaymentsConfirmModal.container';
import SystemDuePaymentsConfirmModal from './duePaymentsConfirmModal/SystemDuePaymentsConfirmModal.container';
import PaginationUniversitiesDuePayments from '../../../commonComponents/paginationComponent/PaginationUniversitiesDuePayments.container';
import { Utils } from '../../../../utils/utils';
import Select from '../../../commonComponents/customSelect/CustomSelect.container';

export const DUE_PAYMENTS_MODE = {
    BA: "BA",
    UNI: "UNI",
    SYSTEM: "SYSTEM"
};

const NO_DATA_LABEL = {
    [DUE_PAYMENTS_MODE.BA]: "no_ba_s_label",
    [DUE_PAYMENTS_MODE.UNI]: "no_uni_s_label",
    [DUE_PAYMENTS_MODE.SYSTEM]: "no_payments_for_system"
};

const NO_FILTER_DATA_LABEL = {
    [DUE_PAYMENTS_MODE.BA]: "no_payments_for_ba_s_label",
    [DUE_PAYMENTS_MODE.UNI]: "no_payments_for_uni_s_label",
};

const NAME_LABEL = {
    [DUE_PAYMENTS_MODE.BA]: "ba_label",
    [DUE_PAYMENTS_MODE.UNI]: "uni_label"
};

const WIRE_DATA_LABEL = {
    [DUE_PAYMENTS_MODE.BA]: "ba_wire_data_label",
    [DUE_PAYMENTS_MODE.UNI]: "uni_wire_data_label"
};

class DuePaymentsList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currentWireData: null,
            currentId: null,
            currentPaidAmount: null,
            currentName: null
        }
    }

    componentDidMount() {
        this.props.onMount();
    }

    componentWillUnmount() {
        if (this.props.onUnmount) {
            this.props.onUnmount();
        }
    }

    render() {
        return (
            <div className='due-payments-component-container'>               
                {this.renderFilter()}
                {
                    this.props.mode === DUE_PAYMENTS_MODE.UNI ?
                        <PaginationUniversitiesDuePayments />
                        : null
                }
                {this.renderContent()}
                {this.renderWireModal()}
                {this.renderConfirmModal()}
            </div>
        )
    }

    renderFilter = () => {
        switch (this.props.mode) {
            case DUE_PAYMENTS_MODE.UNI:
                return (
                    <div className="filters-container">
                        {this.renderContinentAndCountryFilter()}
                        {this.renderNameFilter()}
                    </div>
                );
            case DUE_PAYMENTS_MODE.BA:
                return (
                    <div className="filters-container">
                        {this.renderContinentFilter()}
                        {this.renderNameFilter()}
                    </div>
                );
            default:
                return null;
        }
    }

    renderNameFilter = () => {
        return (
            <div className="name-filter-container">
                <h6 className="name-label">{_.get(this.props.translation, 'system_payment.name_label')}</h6>
                <Input
                    className="name-input"
                    type='text'
                    value={this.props.nameFilter}
                    onChange={this.onChangeNameFilter}
                />
            </div>
        )
    }

    onChangeNameFilter = (e) => {
        this.props.onUpdateNameFilter(e.target.value);
    }

    renderWireModal = () => {
        let props = {
            wireData: this.state.currentWireData,
            name: this.state.currentName
        };

        switch (this.props.mode) {
            case DUE_PAYMENTS_MODE.UNI:
                return <UniversityWireDataModal {...props} />;
            case DUE_PAYMENTS_MODE.BA:
                return <BAWireDataModal {...props} />;
            default:
                return null;
        }
    }

    renderConfirmModal = () => {
        let props = {
            id: this.state.currentId,
            name: this.state.currentName,
            amount: this.state.currentPaidAmount
        };

        switch (this.props.mode) {
            case DUE_PAYMENTS_MODE.UNI:
                return <UniversityDuePaymentsConfirmModal {...props} />;
            case DUE_PAYMENTS_MODE.BA:
                return <BADuePaymentsConfirmModal {...props} />;
            case DUE_PAYMENTS_MODE.SYSTEM:
                return <SystemDuePaymentsConfirmModal {...props} />;
            default:
                return null;
        }
    }

    renderContent() {
        if (this.props.loading) {
            return (
                <div className="due-payments-status-message-container">
                    <h6 className="text-center">{_.get(this.props.translation, sharedLabelsPath.fetching_message)}</h6>
                </div>
            );
        }
        if (_.isNil(this.props.data) || this.props.data.length === 0) {
            return (
                <div className="due-payments-status-message-container">
                    <h6 className="text-center">{_.get(this.props.translation, 'system_payment.' + this.getNoDataLabel())}</h6>
                </div>
            );
        }
        return (
            <Table className='due-payments-table'>
                <thead>
                    <tr>
                        {this.props.mode !== DUE_PAYMENTS_MODE.SYSTEM ?
                            <th>{_.get(this.props.translation, 'system_payment.' + NAME_LABEL[this.props.mode])}</th> : null}
                        <th>{_.get(this.props.translation, 'system_payment.amount_label')}</th>
                        <th className='centered'>{_.get(this.props.translation, 'system_payment.total_aggregated_pay_label')}</th>
                        {this.props.mode !== DUE_PAYMENTS_MODE.SYSTEM ?
                            <th>{_.get(this.props.translation, 'system_payment.' + WIRE_DATA_LABEL[this.props.mode])}</th> : null}
                        <th className="record-payment-th">{_.get(this.props.translation, 'system_payment.record_payment_label')}</th>
                    </tr>
                </thead>
                <tbody>
                    {this.renderPaymentsData()}
                </tbody>
            </Table>
        )
    }

    getNoDataLabel = () => {
        switch (this.props.mode) {
            case DUE_PAYMENTS_MODE.BA:
                return (_.isEmpty(this.props.nameFilter) && _.isNil(this.props.continentFilter) ?
                    NO_DATA_LABEL : NO_FILTER_DATA_LABEL)[DUE_PAYMENTS_MODE.BA];
            case DUE_PAYMENTS_MODE.UNI:
                return (_.isEmpty(this.props.nameFilter) && _.isEmpty(this.props.continentCode)
                && _.isNil(this.props.countryFilter) ? NO_DATA_LABEL : NO_FILTER_DATA_LABEL)[DUE_PAYMENTS_MODE.UNI];
            case DUE_PAYMENTS_MODE.SYSTEM:
                return NO_DATA_LABEL[DUE_PAYMENTS_MODE.SYSTEM];
            default:
                return;
        }
    }

    getTotalPayLabel = (totalPay) => {
        if (_.isEmpty(totalPay)) {
            return "-";
        }
        return totalPay.map(pay => Math.abs(pay.amount) + " " + CURRENCIES[pay.currency]).join(', ');
    };

    renderPaymentsData() {
        return _.map(this.props.data, (data, index) => (
            <tr key={index}>
                {this.props.mode !== DUE_PAYMENTS_MODE.SYSTEM ? <td className='name-td' data-th={_.get(this.props.translation, 'system_payment.' + NAME_LABEL[this.props.mode]) + ':'}>
                    {data.name}
                </td> : null}
                <td className='amount-td' data-th={_.get(this.props.translation, 'system_payment.amount_label') + ':'}>
                    {data.paymentAmount.amount + " " + CURRENCIES[data.paymentAmount.currency]}
                </td>
                <td className='total-pay-td centered' data-th={_.get(this.props.translation, 'system_payment.total_aggregated_pay_label') + ':'}>
                    {this.getTotalPayLabel(data.totalPay)}
                </td>
                {this.props.mode !== DUE_PAYMENTS_MODE.SYSTEM ? <td className='wire-data-td' data-th={_.get(this.props.translation, 'system_payment.' + WIRE_DATA_LABEL[this.props.mode]) + ':'}>
                    <Button color="link" size="sm" onClick={this.onShowWireDataClick(data.wireData, data.name)}>
                        {_.get(this.props.translation, 'system_payment.show_label')}
                    </Button>
                </td> : null}
                <td className='record-payment-td' data-th={_.get(this.props.translation, 'system_payment.record_payment_label') + ':'}>
                    {
                        data.paymentAmount.amount > 0 ?
                            <Button className="olive-green-btn" size="sm" onClick={this.onPaidButtonClick(data.id, data.name, data.paymentAmount)}>
                                {_.get(this.props.translation, 'system_payment.paid_button')}
                            </Button>
                            : null
                    }
                </td>
            </tr >
        ))
    }

    renderContinentFilter = () => {
        let options = [
            { value: null, label: _.get(this.props.translation, sharedLabelsPath.all_label) },
            ...Utils.getLocationOptions(
                this.props.continents,
                _.get(this.props.translation, sharedLabelsPath.continents)
            )
        ];

        return (
            <div className="continent-filter-container">
                <h6>{_.get(this.props.translation, 'system_payment.filter_by_region_label')}</h6>
                <Select
                    className="continent-filter-select"
                    selectedOption={_.find(options, option => option.value === this.props.continentFilter)}
                    options={options}
                    onSelect={this.handleChangeContinentFilterSelect}
                />
            </div>
        )
    };

    renderContinentAndCountryFilter = () => {
        let continentsOptions = [
            { value: null, label: _.get(this.props.translation, sharedLabelsPath.all_label) },
            ...Utils.getLocationOptions(
                this.props.continents,
                _.get(this.props.translation, sharedLabelsPath.continents)
            )
        ];

        let countriesOptions = [
            { value: null, label: _.get(this.props.translation, sharedLabelsPath.all_label) },
            ...Utils.getLocationOptions(
                this.props.countries,
                _.get(this.props.translation, sharedLabelsPath.countries)
            )
        ];

        return [
            <div className="continent-filter-container" key="continent-filter-container">
                <h6>{_.get(this.props.translation, sharedLabelsPath.continent_label)}</h6>
                <Select
                    className="continent-filter-select"
                    selectedOption={_.find(continentsOptions, option => option.value === this.props.continentCode || (_.isEmpty(option.value) && _.isEmpty(this.props.continentCode)))}
                    options={continentsOptions}
                    onSelect={this.handleChangeContinentSelect}
                />
            </div>,
            <div className="country-filter-container" key="country-filter-container">
                <h6>{_.get(this.props.translation, sharedLabelsPath.country_label)}</h6>
                <Select
                    className="country-filter-select"
                    selectedOption={_.find(countriesOptions, option => option.value === this.props.countryFilter)}
                    options={countriesOptions}
                    onSelect={this.handleChangeCountrySelect}
                />
            </div>
        ];
    };

    handleChangeContinentFilterSelect = (selectedOption) => {
        this.props.onChangeContinentFilter(selectedOption.value);
    };

    handleChangeContinentSelect = (selectedOption) => {
        this.props.onSetContinent(selectedOption.value);
        this.props.onChangeCountryFilter(null);
    };

    handleChangeCountrySelect = (selectedOption) => {
        this.props.onChangeCountryFilter(selectedOption.value);
    };


    onShowWireDataClick = (wireData, name) => () => {
        this.setState({
            currentWireData: wireData,
            currentName: name
        });
        this.props.onShowWireDataModal();
    };

    onPaidButtonClick = (id, name, paymentAmount) => () => {
        this.setState({
            currentId: id,
            currentName: name,
            currentPaidAmount: paymentAmount
        });
        this.props.onShowDuePaymentsConfirmModal();
    }
}

DuePaymentsList.propTypes = {
    translation: PropTypes.object.isRequired,
    mode: PropTypes.string.isRequired,
    loading: PropTypes.bool,
    data: PropTypes.array,
    continentFilter: PropTypes.string,
    continentCode: PropTypes.string,
    continents: PropTypes.array,
    countries: PropTypes.array,
    name: PropTypes.string,
    onMount: PropTypes.func.isRequired,
    onUnmount: PropTypes.func,
    onShowWireDataModal: PropTypes.func,
    onShowDuePaymentsConfirmModal: PropTypes.func.isRequired,
    onChangeContinentFilter: PropTypes.func,
    onSetContinent: PropTypes.func,
    onChangeCountryFilter: PropTypes.func,
    onUpdateNameFilter: PropTypes.func
};

export default DuePaymentsList;



// WEBPACK FOOTER //
// ./src/components/paymentManagement/systemPaymentComponent/duePaymentsList/DuePaymentsList.js